import { AFFILIATE_LEVELS } from "../../data/site";
import { useLanguage } from "../../i18n/LanguageContext";
import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";

export const AffiliateBars = () => {
    const { t } = useLanguage();
    return (
        <section data-testid="affiliate-section" className="border-t border-white/5 bg-nx-alt py-20 sm:py-24 lg:py-32">
            <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
                    <div className="lg:col-span-5">
                        <SectionHeader
                            label={t("Affiliate Distribution")}
                            testId="affiliate"
                            title={<>{t("Seven Levels.")}<br />{t("Structured Distribution.")}</>}
                            description={t("50% of every level price flows into affiliate income, distributed across seven levels of the upline chain — 100% transparent and verifiable on-chain.")}
                        />
                        <Reveal delay={0.2} className="mt-8 flex items-baseline gap-3">
                            <span className="text-5xl font-extrabold tracking-tight text-nx-lime tabular">100%</span>
                            <span className="text-xs font-bold uppercase tracking-[0.18em] text-nx-mute">{t("Total Distribution")}</span>
                        </Reveal>
                    </div>
                    <div className="lg:col-span-7">
                        <div className="space-y-4">
                            {AFFILIATE_LEVELS.map((l, i) => (
                                <div key={l.level} className="group" data-testid={`affiliate-bar-${l.level.toLowerCase()}`}>
                                    <div className="mb-1.5 flex items-center justify-between">
                                        <span className="text-xs font-extrabold uppercase tracking-[0.16em] text-nx-text">{l.level}</span>
                                        <span className="text-sm font-extrabold text-nx-lime tabular">{l.pct}%</span>
                                    </div>
                                    <div className="h-2.5 w-full overflow-hidden rounded-full bg-nx-soft">
                                        <div
                                            className={`nx-bar h-full rounded-full ${i === 0 ? "bg-nx-lime" : "bg-gradient-to-r from-nx-blue to-nx-lime/70"}`}
                                            style={{ "--bar-w": `${(l.pct / 40) * 100}%`, animationDelay: `${0.15 + i * 0.1}s` }}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
